import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const dark = tone === 'dark';
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="mx-auto mt-8 w-full max-w-md text-center" role="timer" aria-live="off" data-id="element-19" data-mp="3c0kyrpwpmr4u">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wider ${dark ? 'text-sky-light' : 'text-navy'}`} data-id="element-20" data-mp="3h2a913c3z0rv">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="3729lf577hyhv" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-22" data-mp="10btrg55nluzh">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-23" data-mp="15by3nizj43jw" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="15an2zs1drbx0">
              <span className={`flex h-[72px] w-[78px] items-center justify-center rounded-xl font-serif text-4xl font-black tabular-nums ${dark ? 'bg-white text-navy' : 'bg-navy text-white'}`} data-id="element-25" data-mp="y0epbz8h280f">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className={`mt-1.5 text-xs font-semibold uppercase tracking-wider ${dark ? 'text-sky-light' : 'text-muted'}`} data-id="element-26" data-mp="12seuq77b9t4e">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-black ${dark ? 'text-white' : 'text-navy'}`} data-id="element-27" data-mp="o30jsuo373mw">:</span>}
          </React.Fragment>)}
      </div>
      <p className={`mt-3 text-sm font-extrabold uppercase tracking-wide ${dark ? 'text-white' : 'text-alert'}`} data-id="element-28" data-mp="k03zmziwezgu">
        Limited launch price
      </p>
    </div>;
}